import React from 'react'
import logo from 'assets/img/logo.svg'
import { LoginForm } from 'components'

export const Login = () => {

    return (
        <LoginForm />
    )
}
